
<app-loading></app-loading>
<app-pop-confirm></app-pop-confirm>

  <div class="raw shadow headerfixed" *ngIf="!IsMobile">
        <div class="col-12 header">
            <div id="logo">
                <a routerLink="/home"><img src="../assets/images/logo.png"/></a>
            </div>
            <ul>
                <li routerLink="/activitylist">採購案活動列表</li>
                <li *ngIf="Login" routerLink="/member/mybuyer">儲存買主清單</li>
                <li *ngIf="!Login" (click)="LoginConfirm('/member/mybuyer')">儲存買主清單</li>
                <li *ngIf="Login" routerLink="/member/reserve">我的預約</li>
                <li *ngIf="!Login" (click)="LoginConfirm('/member/reserve')">我的預約</li>
                <li class="bold" *ngIf="!Login" (click)="UserLogin()">登入報名</li>
                <li class="bold" *ngIf="Login" routerLink="/member/reserve">{{Member.name}}</li>
                <li class="bold" *ngIf="Login" (click)="UserLogout()">登出</li>
                <li >{{IsLogin}}</li>

            </ul>
        </div>
  </div>
  <div class="raw mHeader" *ngIf="IsMobile">
      <div class="Fixedmenu">
          <div class="menu {{IsMenu ? 'active' : ''}}" (click)="MenuToggle()">
            <div class="mask" (click)="Mask($event)"></div>
            <ul>
                <li class="close" (click)="Mask($event)"></li>
                <li routerLink="/activitylist">採購案活動列表</li>
                <li routerLink="/member/mybuyer">儲存買主清單</li>
                <li routerLink="/member/reserve">我的預約</li>
                <li class="bold" *ngIf="!Login" (click)="UserLogin()">登入報名</li>
                <li class="bold" *ngIf="Login" routerLink="/member/reserve">{{Member.name}}</li>
                <li class="bold" *ngIf="Login" (click)="UserLogout()">登出</li>
            </ul>
          </div>
          <div id="logo">
            <a routerLink="/home"><img src="../assets/images/logo.png"/></a>
         </div>
         <div class="login" *ngIf="!Login" (click)="UserLogin()"></div>
         <div class="login act" *ngIf="Login" (click)="UserLogout()"></div>
      </div>

  </div>

  <div class="raw">
    <router-outlet></router-outlet>
  </div>

  <footer>
      <div class="col-12 bottom">
          <div class="item">
              <label>相關連結</label>
              <a href="https://info.taiwantrade.com/" target="_blank">台灣經貿網</a>
              <a href="https://events.taiwantrade.com/" target="_blank">活動匯</a>
          </div>
          <div class="item">
              <label>報名活動</label>
              <!-- <a href="http://sourcing.taiwantrade.com.tw/DB/Menu/10e432c6-f04d-4c0b-b2ba-b0199cb734b2.pdf" target="_blank">報名流程說明</a> -->
              <a href="https://isourcing.taiwantrade.com/assets/images/left4.png" target="_blank">報名流程說明</a>
              <a href="https://www.taitra.org.tw/default.aspx" target="_blank">One TAITRA App</a>
          </div>
          <div class="item">
              <label>關於我們</label>
              <!-- <a href="https://isourcing.taiwantrade.com/internet/docdata.aspx?XD=896d2d86-a39d-4f38-b458-aecbb80d46d0" target="_blank">常見問題</a> -->
              <a href="https://info.taiwantrade.com/contract/terms-of-use" target="_blank">網站使用條款</a>
          </div>
          <div class="item">
              <label>聯絡我們</label>
              <a href="mailto:taitra@taitra.org.tw">taitra@taitra.org.tw</a>
              <a href="tel:886227255200" class="phone" >+886  2  2725  5200</a>
          </div>
      </div>
      <div class="col-12 unit">
          <span>主辦單位｜經濟部國際貿易署  <span class="m_device"></span>執行單位｜中華民國對外貿易發展協會</span>
          <span class="copyright">©{{copyRightY}} by Taiwan External Trade Development Council(TAITRA). All right reserved.</span>
      </div>
  </footer>

  <div id="top" class="backTop {{iscookie ? 'cookieShow' : ''}}"></div>
  <cookie-box></cookie-box>
